import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';

import { NgUtils } from 'tiime-expert-utils';
import { TiimeFormModule, TiimeInputContainerModule, TiimeOptionModule, TiimeSelectModule } from 'tiime-material';

import { CreatePcgEntryDialogModule } from '@modules/shared/dialogs/create-pcg-entry-dialog/create-pcg-entry-dialog.module';

@Component({
  standalone: true,
  selector: 'app-generic-email-select',
  templateUrl: './generic-email-select.component.html',
  styleUrls: ['./generic-email-select.component.scss'],
  imports: [
    CreatePcgEntryDialogModule,
    TiimeInputContainerModule,
    TiimeSelectModule,
    TiimeFormModule,
    ReactiveFormsModule,
    TiimeOptionModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GenericEmailSelectComponent {
  @Input() genericEmailControl: UntypedFormControl;
  @Input() genericEmails: string[];
  @Input() label = 'Email';
  @Input() required: boolean;

  readonly trackByIndex = NgUtils.trackByIndex;
}
